$(document).ready(function () {
    var spans = $('.article-template__content.rte p span');

    //style属性内の文字列の取得
    spans.each(function () {
        var style = $(this).attr('style');

        // style属性が存在するかつ、text-decoration: underline;という文字列が含まれていた場合の処理
        if (style && style.includes('text-decoration: underline;')) {
            $(this).css('font-weight', 'bold');
            $(this).css('background', 'rgba(0,0,0,0) linear-gradient(transparent 60%,#ffc0c0 0%) repeat scroll 0 0');
            $(this).css('padding-bottom', '3px');
            $(this).css('text-decoration', 'none');
        }
    });
});